<template>
    <v-select :items="recipients" item-text="name" item-value="phone" :value="value" @input="syncValue"
              :hint="value ? `Tlf. ${formatPhoneNumber(value.phone)}, ${value.name}` : ''" persistent-hint return-object></v-select>
</template>

<script>
import {formatPhoneNumber} from "@/helpers";

export default {
    props: {
        value: {
            type: Object,
            default: null
        },
        customerId: {
            type: Number,
            required: false
        },
        carId: {
            type: Number,
            required: false
        }
    },

    data() {
        return {
            loading: false,
            recipients: []
        }
    },

    created() {
        this.loadData();
    },

    methods: {
        formatPhoneNumber,
        loadData() {
            let params = {
                customer: this.customerId,
                car: this.carId
            };
            this.loading = true;
            this.$http.get(`sms/recipients/customer`, {params}).then(response => {
                this.recipients = response.data.data;
                this.$emit('input', this.recipients[0]);
            }).finally(() => {
                this.loading = false;
            });
        },

        syncValue(value) {
            this.$emit('input', value);
        }
    },
}
</script>

<style scoped>

</style>
